/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-target-blank */
const React = require('react');
const CarouselSnapped = require('@andes/carousel-snapped');
const { Title } = require('@andes-landings/title');
const CarouselCardDesktopStandar = require('./components/CarrouselItem/carrousel');
const DemoCards = require('./components/DemoCards');


const Demonstrations = ({ i18n, lang, isMobile, siteId, brand }) => {
  const getLocalizedBrand = (langName) => {
    if (brand === 'yellowblue-light') {
      return `re-${langName}`;
    }
    return langName;
  };

  const cards = DemoCards(getLocalizedBrand(lang), lang, i18n, siteId);


  return (
    <div className={`demonstration-container demonstration-${brand}`} id="demonstrations">
      <div className="demonstration-content">
        <Title
          className="documentation-title"
          title={i18n.gettext('Prueba cómo funcionan')}
          description={isMobile ? i18n.gettext('Crea una experiencia visual de las soluciones en tiempo real y copia el código para agregarlo a tu sitio o compartirlo.')
            : i18n.gettext('Crea una experiencia visual en tiempo real y copia el código para agregarlo a tu sitio o compartirlo con un desarrollador.')}
          isHero
          align="center"
            />
        <CarouselSnapped
          className="demonstration-content-cards"
          type="content"
          scroll="hidden"
          arrows={!isMobile}
          slidesPerView={isMobile ? 1 : 4}
          spacing={16}
          lazyload>
          {cards.map((card) => (
            <CarouselCardDesktopStandar
              pillText={card.pillText}
              title={card.description}
              url={card.url}
              linkDescription={card.linkDescription}
              tracking={card.tracking}
              label={card.label}
              iconCard={card.icon} />
          ))}
        </CarouselSnapped>
      </div>
    </div>
  );
};

module.exports = Demonstrations;
